'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import {
    ClockIcon,
    GalleryIcon,
    HashtagIcon,
    LoadingIcon,
    MessageTextIcon,
    SparklesIcon
} from '@insta-club/components';
import { Post } from '@insta-club/models';
import { useSessionStore } from '@insta-club/state';
import { t } from '@insta-club/translations';
import { Checkbox } from '@insta-club/ui';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { mutate } from 'swr';
import useSWRMutation from 'swr/mutation';
import TaskItem from '../task-item';

interface Props {
    post: Post;
    hasChatBot: boolean;
    programID: number;
    dayNumber: number;
    canPerformTask: boolean;
    // onGuide: (guide: Guides) => void;
}

const PostingProgram: React.FC<Props> = ({
    post,
    hasChatBot,
    programID,
    dayNumber,
    canPerformTask
    //  onGuide
}) => {
    const settings = useSessionStore((state) => state.settings);
    const router = useRouter();
    const [loading, setLoading] = useState(false);
    const [checked, setChecked] = useState(post.is_done);
    const { trigger } = useSWRMutation(
        ApiKeys.POST_PROGRAM_TOGGLE_TASK(programID),
        (url, { arg }: { arg: { type: string; day_number: number } }) =>
            fetcher(url, 'dashboard', 'POST', { body: arg })
    );

    const handleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = e.target.checked;
        setLoading(true);
        setChecked(checked);
        try {
            await trigger({
                type: 'post',
                day_number: dayNumber
            });
            mutate(ApiKeys.GET_PROGRAM_SHOW(programID, dayNumber));
        } catch (err: unknown) {
            toast.removeAll();
            if (err instanceof Error) {
                toast.error('خطای ناشناخته رخ داده است');
            } else {
                const error = err as { status: number; message: string };
                if (error.status && error.status == 400) {
                    toast.error('وضعیت تسک های برنامه فقط در همان روز یا روز بعد قابل بروز رسانی می باشند.');
                }
            }
            setChecked(!checked);
        } finally {
            setLoading(false);
        }
    };

    const handelClickChat = () => {
        if (settings?.settings?.chat_bot_active) {
            router.push(`/assistant/chat/${post.id}`);
        } else {
            toast.error(t('service_temporarily_unavailable'));
        }
    };

    return (
        <div className='flex flex-col gap-4'>
            {/* <div className='flex items-center justify-between'>
                <p className='text-base font-semibold text-gray-600'>شرایط پست گذاری</p>
            </div> */}
            <div className='custom-scrollbar flex max-h-96 flex-col divide-y divide-gray-200 overflow-y-auto rounded-xl bg-gray-100 px-3'>
                {post.posted_at ? (
                    <TaskItem
                        title='زمان انتشار'
                        value={`${post.posted_at.h}:${post.posted_at.m} تا ${post.posted_at_2.h}:${post.posted_at_2.m}`}
                        icon={<ClockIcon />}
                    />
                ) : null}
                {post.post_type?.type ? (
                    <TaskItem title='نوع پست' value={post.post_type.type} icon={<GalleryIcon />} />
                ) : null}
                {post.post_type?.subject ? (
                    <TaskItem title='موضوع' value={post.post_type.subject} icon={<MessageTextIcon />} />
                ) : null}
                {post.hashtag_count && post.hashtag_count > 0 ? (
                    <TaskItem title='هشتگ' value={`${post.hashtag_count} عدد`} icon={<HashtagIcon />} />
                ) : null}
            </div>
            <div className='flex items-center justify-between'>
                <div
                    className={`mt-2 flex items-center justify-between ${loading ? 'pointer-events-none cursor-not-allowed opacity-60' : ''}`}
                >
                    {canPerformTask && (
                        <Checkbox
                            color='green'
                            checked={checked}
                            onChange={handleChange}
                            disabled={loading}
                            label={<span className='text-sm font-medium text-gray-600'>انجام شد</span>}
                        />
                    )}
                    {loading ? <LoadingIcon width={20} height={20} /> : null}
                </div>
                <div className='my-2 flex flex-col gap-2'>
                    {hasChatBot ? (
                        <button
                            onClick={handelClickChat}
                            className='bg-primary-500 flex cursor-pointer items-center space-x-1 rounded-full px-5 py-1 text-xs font-medium text-white'
                        >
                            <SparklesIcon />
                            <span>{t('post_idea_with_intelligence')}</span>
                        </button>
                    ) : // <Button onClick={handelClickChat} variant='outline' size='sm' icon={<BotIcon />}>
                    //     {t('post_idea_with_intelligence')}
                    // </Button>
                    null}
                    {/* <Button className='!bg-gray-100 !text-gray-700' size='sm'>
                    {t('idea_for_post', '(اسلایدی)')}
                </Button> */}
                </div>
            </div>
        </div>
    );
};

export default PostingProgram;

